import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailInformationProps as Props } from './types';
import type { CompanyDetailInformation } from '../../../types/companyDetail';
import { getCompanyProfile } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [profile, setProfile] = useState<CompanyDetailInformation>({
    informationTitle: null,
    informationDescription: null,
    informationImage1: null,
    informationImage1Description: null,
    informationImage2: null,
    informationImage2Description: null,
    missionTitle: null,
    missionDescription: null,
    missionImage1: null,
    missionImage1Description: null,
    missionImage2: null,
    missionImage2Description: null,    
  });


  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getCompanyProfile(props.company.id);
        setProfile({
          informationTitle: response.informationTitle,
          informationDescription: response.informationDescription,
          informationImage1: response.informationImage1,
          informationImage1Description: response.informationImage1Description,
          informationImage2: response.informationImage2,
          informationImage2Description: response.informationImage2Description,
          missionTitle: response.missionTitle,
          missionDescription: response.missionDescription,
          missionImage1: response.missionImage1,
          missionImage1Description: response.missionImage1Description,
          missionImage2: response.missionImage2,
          missionImage2Description: response.missionImage2Description,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchProfile();
  }, [props.company.id]);

  return (
    <Presentation
      isPc={props.isPc}
      informationFixedTitle={props.informationFixedTitle}
      missionFixedTitle={props.missionFixedTitle}
      profile={profile}
    />
  );
};